//Package
import { defineComponent } from "vue";

// Component
import Typography from "@/components/general/Typography";

export default defineComponent({
  props: {
    items: {
      type: Array,
      required: true,
      default: ()=>[],
    },
  },
  components: {
    Typography
  },
});
